import { useState } from 'react';
import { WellsFargoSettingsApi } from '@/api/clients/wells-fargo-settings/wells-fargo-settings.api';

export const useDeleteWellsFargoWebhookSubscription = () => {
  const [loading, setLoading] = useState(false);

  const deleteSubscription = async (organizationId) => {
    setLoading(true);
    try {
      return await WellsFargoSettingsApi.deleteWebhookSubscription(
        organizationId,
      );
    } finally {
      setLoading(false);
    }
  };

  return { deleteSubscription, loading };
};
